module.exports = __webpack_public_path__ + "img/04.82ae7d08.png";